<label for="event-select+{{dropDownName}}+{{index}}" [ngStyle]="{'width':width ? width : '640px'}"
    class="video-select-div module-select outline-div-input" [title]="!enableCustomTooltip ? selectedEvent : ''"
    [class]="classNames" (keypress)="dropDownDivOpen(dropDownName,Input)"
    (click)="!disabled && dropDownDivOpen(dropDownName,Input)"
    [ngClass]="{ 'ddOpened' :ddOpen && ddName === dropDownName,'disabled':disabled}">

    <img alt="search" src="assets/Channels/Search.svg" class="input-search" [hidden]="disableSearch || disabled">

    <input [disabled]="disabled" id="event-select+{{dropDownName}}+{{index}}" class="channel-input" #Input
        [placeholder]="selectedEvent ? '' : ( (isCreateFlowDropdown && headingText !== 'Not Available' ? 'Select ' + headingText : headingText) | truncateString:50 )"
        [(ngModel)]="searchText" (mousedown)="dropDownDivOpen(dropDownName,Input)" (blur)="dropDownDivOpen('')"
        (keydown.space)="$event.stopPropagation()" (keypress)="!disableSearch" (keyup)="searchEvents()"
        autocomplete="off" [ngClass]="disableSearch ? 'no-search' : ''"
        [title]="!enableCustomTooltip ? selectedEvent : ''" [matTooltip]="customTooltipText"
        [matTooltipClass]="enableCustomTooltip ? customTooltipClass : ''" matTooltipShowDelay="0"
        matTooltipHideDelay="0">

    <span class="video-source display-selected" [ngClass]="disableSearch ? 'no-search' : ''"
        *ngIf="selectedEvent && !searchText">{{selectedEvent}}</span>

    <img alt="close" src="assets/Channels/close.svg" class="input-close"
        [ngClass]="{'show-close':!disabled && !disableClose && selectedEvent}" (keypress)="onClear($event)"
        (click)="onClear($event)">

    <img alt="arrow" src="assets/Channels/Shape.svg" class="input-arrow">
</label>

<div class="channel-dropdown-panel module-individual" [ngStyle]="{'width':width ? width : '640px' }"
    *ngIf="!isCreateFlowDropdown" [class]="classNames" [ngClass]="{ 'expanded' : ddOpen && ddName === dropDownName}">
    <span *ngIf="searchText && getFilteredList().length === 0" class="no-record-found">No results found</span>
    <span *ngIf="list?.length === 0 && !searchText" class="no-record-found">No results found</span>

    <div class="dropdown-scroll-container">
        <div class="options-div" *ngFor="let state of getFilteredList(); trackBy: trackByFn" [title]="state.key"
        [ngClass]="{'show-value': assignTicket}">
            <div class="option-value flex-column" (mousedown)="submitValue(state)"
                [ngClass]="{'selected': state.key === selectedEvent}">
                <span [title]="state.key">
                    {{state.key}}
                </span>
                <span *ngIf="state.value && assignTicket" class="option-sub-value" [title]="state.value">
                    {{state.value}}
                </span>
            </div>
        </div>

    </div>
</div>
<div class="channel-dropdown-panel module-individual" [ngStyle]="{'width':width ? width : '640px' }"
    *ngIf="isCreateFlowDropdown" [class]="classNames" [ngClass]="{ 'expanded' : ddOpen && ddName === dropDownName}">
    <div class="dropdown-scroll-container">
        <span *ngIf="(filterList || getFilteredListForCreateFlow()).length === 0" class="no-record-found">
            No results found
        </span>
        <ng-container
            *ngFor="let state of (filterList || getFilteredListForCreateFlow()); let i = index; trackBy: trackByFn">
            <div class="dropdown-header"
                *ngIf="state.group && (i === 0 || state.group !== (filterList || getFilteredListForCreateFlow())[i - 1]?.group)">
                {{ state.group }}
            </div>
            <div class="options-div create-flow-dropdown" *ngIf="state.key" [title]="state.key">
                <div class="option-value flex-column" (mousedown)="submitValue(state)"
                    [ngClass]="{'selected': state.key === selectedEvent}">
                    <span [title]="state.key">
                        {{ state.key }}
                    </span>
                </div>
            </div>
        </ng-container>
    </div>
</div>